// Stato e helper condivisi tra la lista, Create.vue ed Edit.vue della sezione Gestione > Pagamenti.

export const PAYMENT_STATUS = {
	pending: { label: 'In attesa', color: 'warning' },
	paid: { label: 'Pagato', color: 'success' },
};

export const statusItems = [
	{ text: PAYMENT_STATUS.pending.label, value: 'pending' },
	{ text: PAYMENT_STATUS.paid.label, value: 'paid' },
];

export const billingItems = [
	{ text: 'Fisso', value: 'fixed' },
	{ text: 'Commissione', value: 'commission' },
];

export function statusLabel(value) {
	return (PAYMENT_STATUS[value] || {}).label || 'In attesa';
}

export function statusColor(value) {
	return (PAYMENT_STATUS[value] || {}).color || 'warning';
}

export function emptyPayment() {
	return {
		_id: '',
		code: '',
		_profile: '',
		merchant: { name: '', email: '', website: '' },
		billingType: 'fixed',
		months: 12,
		value: 0,
		// sentinella: con `null` il backend ripiega sul minimo garantito del profilo, con 0 lo
		// sovrascriverebbe (e' il bug che affligge gia' `months` e `value`, sempre inviati)
		min: null,
		period: { from: null, to: null },
		orders: { count: 0, total: 0 },
		amount: 0,
		status: 'pending',
		paidAt: null,
		note: '',
		auto: true,
	};
}

// merge dei dati della lista sulla struttura di default, senza perdere i sotto-oggetti
export function fillPayment(data) {
	const form = emptyPayment();
	const source = data || {};
	const nested = ['merchant', 'period', 'orders'];

	Object.keys(form).forEach(key => {
		if (nested.includes(key)) return;
		if (source[key] !== undefined && source[key] !== null) {
			form[key] = source[key];
		}
	});

	nested.forEach(key => {
		if (source[key]) {
			form[key] = Object.assign({}, form[key], source[key]);
		}
	});

	return form;
}

export function validatePayment(form) {
	const messages = { _profile: '', amount: '' };
	const errors = [];

	if (!form._profile) {
		messages._profile = 'Merchant richiesto';
		errors.push('Merchant richiesto');
	}

	const amount = Number(form.amount);
	if (isNaN(amount) || amount < 0) {
		messages.amount = 'Importo non valido';
		errors.push('Importo non valido');
	}

	return { messages, errors };
}
